export default __webpack_public_path__ + "static/media/collegebg.79cb867f.svg";